import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/navigation";
import { useEffect, useRef } from "react";

/* ================= VEHICLE DATA ================= */
const vehicles = [
  {
    name: "Victoris",
    image: require('../assets/banners-2/victories-removebg-preview.png'),
    tagline1: "For the ones who have it all",
    tagline2: "Presenting",
    bgColor: "#FFD400",
    patternColor: "rgba(255,0,0,0.35)",
    textColor: "text-black",
    link: "/vehicles/victoris",
  },
  {
    name: "Grand Vitara",
    image: require('../assets/banners-2/grand-vitar.png'),
    tagline1: "For those who want more",
    tagline2: "Presenting",
    bgColor: "#6D181F",
    patternColor: "rgba(255,255,255,0.25)",
    textColor: "text-white",
    link: "/vehicles/grandvitara",
  },
];

/* ================= COMPONENT ================= */
const ProductOfMonth = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      autoplay={{ delay: 4500, disableOnInteraction: false }}
      loop
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
      }}
      className="relative"
    >
      {vehicles.map((item, index) => (
        <SwiperSlide key={index}>
          {/* SLIDE WRAPPER */}
          <section
            className="relative overflow-hidden"
            style={{ backgroundColor: item.bgColor }}
          >
            {/* DOT PATTERN */}
            <div
              className="absolute top-0 right-0 w-1/2 h-full opacity-60"
              style={{
                backgroundImage: `radial-gradient(circle, ${item.patternColor} 1px, transparent 1px)`,
                backgroundSize: "12px 12px",
              }}
            />

            {/* CONTENT */}
            <div className="relative grid items-center grid-cols-1 gap-10 px-6 py-20 mx-auto max-w-7xl lg:grid-cols-2">
              {/* LEFT */}
              <div data-aos="fade-right" className="flex flex-col items-center text-center lg:items-end lg:text-right">
                <h1
                  className={`font-extrabold italic uppercase leading-tight
                  text-4xl  sm:text-5xl lg:text-6xl ${item.textColor}`}
                >
                  Product of <br /> the Month
                </h1>

                <div
                  className={`flex items-center gap-4 mt-6 ${item.textColor}`}
                >
                  <p className="text-sm font-semibold tracking-widest uppercase">
                    {item.tagline1}
                  </p>

                  <div
                    className={`h-10 w-[1px] ${item.textColor === "text-white"
                        ? "bg-white"
                        : "bg-black"
                      }`}
                  ></div>

                  <p className="text-sm font-semibold tracking-widest uppercase">
                    {item.tagline2} <br />
                    <span className="font-extrabold">{item.name}</span>
                  </p>
                </div>

                <Link
                  to={item.link}
                  className="self-center lg:self-end lg:mr-48"
                >
                  <button
                    className="mt-8 bg-red-600 hover:bg-[#253E72] text-white font-bold
                    px-10 py-4 rounded-full text-lg transition-all duration-300 shadow-lg "
                    data-aos="zoom-in"
                    data-aos-delay="300"
                  >
                    KNOW MORE
                  </button>
                </Link>
              </div>

              {/* RIGHT IMAGE */}
              <div
                className="flex justify-center lg:justify-end"
                data-aos="fade-left"
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="object-contain w-full max-w-2xl transition-transform duration-500 lg:max-w-3xl xl:max-w-4xl drop-shadow-2xl hover:-translate-y-2"
                />
              </div>
            </div>
          </section>
        </SwiperSlide>
      ))}

      {/* NAV BUTTONS */}
      <button
        ref={prevRef}
        className="absolute z-20 text-blue-600 -translate-y-1/2 left-6 top-1/2"
      >
        <FaChevronLeft size={32} />
      </button>

      <button
        ref={nextRef}
        className="absolute z-20 text-blue-600 -translate-y-1/2 right-6 top-1/2"
      >
        <FaChevronRight size={32} />
      </button>
    </Swiper>
  );
};

export default ProductOfMonth;
